import { h, Component } from 'preact';
import { loadScript } from 'app/common/helpers/page';

export default class FacebookSigninButton extends Component {
  constructor(props) {
    super(props);
    this.fbLoaded = false;

    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    const { user } = this.props;

    // do not load it for signed in user
    if (user) {
      return;
    }
  }

  componentDidUpdate(prevProp) {
    const { locale } = window.I18n;

    if (prevProp.loaded !== this.props.loaded && this.props.loaded) {
      loadScript(
        `https://connect.facebook.net/${locale}/sdk.js`,
        'facebook-jssdk'
      )
        .then(() => {
          this.fbLoaded = true;
        })
        .catch(() => {});
    }
  }

  handleClick(e) {
    e.preventDefault();
    const { signInWithFacebook } = this.props;
    if (!this.fbLoaded) {
      return;
    }

    signInWithFacebook();
  }

  render() {
    return (
      <button
        className="btn ls-btn-facebook"
        id="ls-btn-facebook"
        tabIndex="0"
        type="button"
        data-bhw="FacebookLogin"
        onClick={this.handleClick}
      >
        Facebook
      </button>
    );
  }
}
